import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Noto_Sans\",\"arguments\":[{\"subsets\":[\"latin\"],\"weight\":\"400\"}],\"variableName\":\"font\"}");
;
import(/* webpackMode: "eager" */ "/app/src/app/print.css");
;
import(/* webpackMode: "eager", webpackExports: ["ProjectFunctionalWrapper"] */ "/app/src/components/context/ProjectFunctionalWrapper/ProjectFunctionalWrapper.tsx");
